export default __webpack_public_path__ + "static/media/review1.92768047.mp4";